import { createRoutine } from 'redux-saga-routines';

export const fetchTeamsRoutine = createRoutine('FETCH_TEAMS');
export const createTeamRoutine = createRoutine('CREATE_TEAM');
export const updateTeamRoutine = createRoutine('UPDATE_TEAM');
export const deleteTeamRoutine = createRoutine('DELETE_TEAM');
export const getTeamUsersCountRoutine = createRoutine('GET_TEAM_USERS_COUNT');
